import React, { createContext, useContext } from 'react'

interface AppDownloadModalContextValue {
  isAppDownloadModalBlockingLegacy: boolean
}

const AppDownloadModalContext = createContext<AppDownloadModalContextValue>({
  isAppDownloadModalBlockingLegacy: false
})

export const AppDownloadModalProvider = ({
  children,
  isAppDownloadModalBlockingLegacy
}: AppDownloadModalContextValue & {
  children: React.ReactNode
}): React.ReactElement => {
  return (
    <AppDownloadModalContext.Provider
      value={{ isAppDownloadModalBlockingLegacy }}
    >
      {children}
    </AppDownloadModalContext.Provider>
  )
}

export const useAppDownloadModalContext = (): AppDownloadModalContextValue => {
  return useContext(AppDownloadModalContext)
}
